<template>
  <div>
    <breadcrumbs></breadcrumbs>

    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="设备类型" prop="serverId" v-if="typeArr.length > 1">
        <el-select
          disabled
          v-model="form.serverId"
          placeholder="请选择设备类型"
        >
          <el-option
            v-for="(v, i) in typeArr"
            :key="i"
            :label="v.name"
            :value="v.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入角色名称"
          maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色场景">
        <el-checkbox-group v-model="form.roleType">
          <el-checkbox
            v-for="(v, i) in sceneInfo"
            :key="i"
            :label="
              v == 1
                ? '景区场景'
                : v == 2
                ? '校园场景'
                : v == 3
                ? '社区场景'
                : ''
            "
            :name="v"
          ></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="角色权限">
        <el-tabs type="border-card" @tab-click="lookList">
          <el-tab-pane
            v-if="form.roleType.indexOf(v) !== -1"
            v-for="(v, i) in rolePermission"
            :key="i"
            :label="v"
            :name="v"
            :data="JSON.stringify(v)"
          >
            <!--新增修改界面-->
            <el-form :model="roleForm" label-width="80px">
              <el-form-item prop="menuBtn">
                <!-- <el-input
                  placeholder="输入关键字进行过滤"
                  v-model="filterTree"
                ></el-input> -->
                <el-tree
                  :filter-node-method="filterNode"
                  :ref="'tree' + i"
                  :data="menulistTreeData"
                  show-checkbox
                  :check-strictly="false"
                  :default-expand-all="false"
                  node-key="key"
                  :default-checked-keys="[]"
                  :props="{
                    label: 'menuName',
                    children: 'children',
                    disabled: 'disabled',
                  }"
                >
                </el-tree>
              </el-form-item>
            </el-form>
            <div class="dialog-footer">
              <el-button @click="$router.push('/sys/role')">取消</el-button>
              <el-button type="primary" @click.native="submit('form', v, i)"
                >保存</el-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },

  data() {
    const name = (rule, value, callback) => {
      var reg = /^[a-zA-Z\u4e00-\u9fa5]+$/;
      if (!value) {
        callback(new Error("请填写角色名称"));
      } else if (!reg.test(value)) {
        callback(new Error("仅支持中英文，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      sceneInfo: [],
      sceneInfo2: [],
      form: {
        name: "",
        roleType: [],
        serverId: "1",
      },
      rolePermission: [], //角色权限
      roleForm: {
        menuBtn: {},
        roleName: "",
      },
      menulistTreeData: [], //树结构
      filterTree: "", //关键字输入查询
      btnlistData: [], //按钮列表
      menulistData: [],

      rules: {
        name: [{ required: true, validator: name, trigger: "blur" }],
        serverId: [
          { required: true, message: "请选择设备类型", trigger: "blur" },
        ],
      },
      treeName: "",
      tree: null,
      i: null,
      typeArr: null,
    };
  },
  created() {
    this.sceneInfo = JSON.parse(localStorage.getItem("sceneInfo"));
    this.sceneInfo.forEach((v) => {
      if (v == 1) {
        this.form.roleType.push("景区场景");
      } else if (v == 2) {
        this.form.roleType.push("校园场景");
      } else if (v == 3) {
        this.form.roleType.push("社区场景");
      } else {
        return;
      }
    });
    this.getShebeiType();
    this.rolePermission = this.form.roleType;

    // this.btnlist();

    // this.$nextTick((e) => {
    //   this.$refs.tree.setCheckedKeys([]);
    //   console.log(this.$refs.tree, "树2");
    // });
  },
  watch: {
    filterTree(val) {
      this.$refs.tree0.filter(val);
      this.$refs.tree1.filter(val);
      this.$refs.tree2.filter(val);
    },
  },
  methods: {
    // 字典表
    getShebeiType() {
      // this.$api.dict.list({ dictName: "服务管理" }).then((res) => {
      //   if (res.code === 200) {
      //     console.log(res, "字典表");
      //     this.typeArr = [];

      //     res.data.forEach((v) => {
      //       if (v.dictPid !== 0) {
      //         this.typeArr.push(v);
      //       }
      //     });
      //   }
      // });
      this.$api.home.serverHttp().then((res) => {
        if (res.code === 200) {
          // this.typeArr = res.data;
          let typeArr = res.data;
          this.getFuwu(typeArr).then((updatedServerArr) => {
            this.typeArr = updatedServerArr;
          });
        }
      });
    },
    getFuwu(n) {
      // 返回一个 Promise
      return new Promise((resolve, reject) => {
        this.$api.dict
          .list({ dictName: "服务管理" })
          .then((res) => {
            if (res.code === 200) {
              let arr = n.map((itemA) => {
                // 在 B 数组中查找匹配的项
                let matchedItemB = res.data.find(
                  (itemB) => itemB.dictValue === itemA.id
                );

                // 如果找到匹配项，更新 itemA 的 name 字段
                if (matchedItemB) {
                  itemA.name = matchedItemB.dictName;
                }

                return itemA;
              });

              // 解析 Promise，返回更新后的数组
              resolve(arr);
            } else {
              // 如果请求失败，拒绝 Promise
              reject(new Error("Failed to fetch dictionary list."));
            }
          })
          .catch((error) => {
            // 捕获并处理任何网络错误或其他异常
            reject(error);
          });
      });
    },
    lookList(v) {
      console.log(JSON.parse(v.$attrs.data));
      this.btnlist(
        JSON.parse(v.$attrs.data) == "景区场景"
          ? 1
          : JSON.parse(v.$attrs.data) == "校园场景"
          ? 2
          : JSON.parse(v.$attrs.data) == "社区场景"
          ? 3
          : ""
      );
    },
    getMenuBtn() {
      if (this.treeName === "景区场景" && this.i == 0) {
        this.tree = this.$refs.tree0[0].getCheckedNodes();
      } else if (this.treeName === "景区场景" && this.i == 1) {
        this.tree = this.$refs.tree1[0].getCheckedNodes();
      } else if (this.treeName === "景区场景" && this.i == 2) {
        this.tree = this.$refs.tree2[0].getCheckedNodes();
      } else if (this.treeName === "校园场景" && this.i == 0) {
        this.tree = this.$refs.tree0[0].getCheckedNodes();
      } else if (this.treeName === "校园场景" && this.i == 1) {
        this.tree = this.$refs.tree1[0].getCheckedNodes();
      } else if (this.treeName === "校园场景" && this.i == 2) {
        this.tree = this.$refs.tree2[0].getCheckedNodes();
      } else if (this.treeName === "社区场景" && this.i == 0) {
        this.tree = this.$refs.tree0[0].getCheckedNodes();
      } else if (this.treeName === "社区场景" && this.i == 1) {
        this.tree = this.$refs.tree1[0].getCheckedNodes();
      } else if (this.treeName === "社区场景" && this.i == 2) {
        this.tree = this.$refs.tree2[0].getCheckedNodes();
      }

      var menuBtn = {};
      var menubtn = this.tree.filter((e) => e.type == "btn");
      menubtn.forEach((e) => {
        if (!menuBtn[e.pid]) {
          var btns = [];
          menubtn.forEach((b) => {
            if (b.pid == e.pid && b.menuId) {
              btns.push(b.menuId);
            }
          });
          menuBtn[e.pid] = btns.join(",");
        }
      });
      return menuBtn;
    },
    submit(formName, v, i) {
      let that = this;
      that.treeName = v;
      that.i = i;
      console.log(v, "v");
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.roleForm.roleName = that.form.name;
          this.roleForm.serverId =
            that.typeArr.length > 1 ? that.form.serverId : that.typeArr[0].id;
          if (v === "景区场景") {
            that.roleForm.menuBtn = that.getMenuBtn();
            that.roleForm.sceneId = 1;

            that.$api.role
              .addRole(that.roleForm)
              .then((d) => {
                if (d.code == 200) {
                  that.$message({
                    message: "设置成功",
                    type: "success",
                  });
                  that.addORUpdateVisible = false;
                  that.$refs.roleForm.resetFields();

                  that.rolelist();
                } else {
                  that.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else if (v === "校园场景") {
            that.roleForm.menuBtn = {};
            that.roleForm.menuBtn = that.getMenuBtn();
            that.roleForm.sceneId = 2;
            that.$api.role
              .addRole(that.roleForm)
              .then((d) => {
                if (d.code == 200) {
                  that.$message({
                    message: "设置成功",
                    type: "success",
                  });
                  that.addORUpdateVisible = false;
                  that.$refs.roleForm.resetFields();

                  that.rolelist();
                } else {
                  that.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            that.roleForm.menuBtn = {};
            that.roleForm.menuBtn = that.getMenuBtn();
            console.log(that.roleForm.menuBtn, "社区");
            that.roleForm.sceneId = 3;
            that.$api.role
              .addRole(that.roleForm)
              .then((d) => {
                if (d.code == 200) {
                  that.$message({
                    message: "设置成功",
                    type: "success",
                  });
                  that.addORUpdateVisible = false;
                  that.$refs.roleForm.resetFields();

                  that.rolelist();
                } else {
                  that.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // lookList(v) {
    //   console.log(1);
    //   //获取接口
    //   this.$api.role.info().then((d) => {
    //     console.log(d, "角色详情");
    //     if (d.code == 200) {
    //       this.addORUpdateVisible = true;
    //       this.$nextTick((e) => {
    //         var keys = [];
    //         for (var key in d.data.ifMap) {
    //           if (d.data.ifMap[key].menuInfo) {
    //             var menuBtnList = d.data.ifMap[key].menuBtnList;
    //             if (!menuBtnList || (menuBtnList && menuBtnList.length == 0)) {
    //               keys.push(key + "btn_" + key);
    //             } else {
    //               var btnIds = [];
    //               menuBtnList.forEach((e) => {
    //                 keys.push(key + "btn" + e.btnId);
    //                 btnIds.join(e.btnId);
    //               });
    //               if (
    //                 this.menulistData.findIndex(
    //                   (e) => e.btnIds == btnIds.join(",")
    //                 ) >= 0
    //               )
    //                 keys.push(key + "btn_" + key);
    //             }
    //           }
    //         }
    //         console.log(keys, "keys");
    //         this.$refs.tree0[0].setCheckedKeys(keys);
    //       });
    //     } else {
    //       this.$message.error(d.msg);
    //     }
    //   });
    // },

    handleClick(v) {
      console.log(v, 5555);
    },
    btnlist(a) {
      //获取接口
      this.$api.system
        .btnlist({})
        .then((d) => {
          console.log(d, "按钮");
          if (d.code == 200) {
            d.data.forEach((e) => {
              e.btnId = e.btnId + "";
            });
            this.btnlistData = d.data;
            this.menulist(a);
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    menulist(a) {
      //获取接口
      this.$api.system
        .sceneMenuList({ sceneId: a, serverId: 1 })
        .then((d) => {
          if (d.code == 200) {
            var menus = [];
            this.$store.state.menu.forEach((c) => {
              menus.push(c);
              c.children.forEach((a) => {
                menus.push(a);
              });
            });
            var r = [];
            d.data.forEach((e) => {
              r.push(e);
              if (menus.findIndex((c) => c.menuId == e.menuId) >= 0) {
                r.push(e);
              }
            });
            // console.log(111111111111111111, d.data);
            this.menulistData = d.data;
            this.getdata(this.menulistData);
            // console.log(11231, this.menulistData);
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getdata(nowdata, isde) {
      // tree 数据组装
      var data = nowdata.filter((e) => e.pid == 0);
      var temp = [];
      data.forEach((e) => {
        e.children = nowdata.filter((c) => c.pid == e.menuId);
        // console.log(1111, e);
        e.disabled = e.status == 0;
        e.type = "menu";
        e.key = "menu" + e.menuId;
        if (e.children && e.children.length > 0) {
          e.children.forEach((c) => {
            c.disabled = c.status == 0;
            c.deep = 1;
            c.type = "menu";
            c.key = "menu" + c.menuId;
            c.children = [
              {
                type: "btn",
                key: c.menuId + "btn_" + c.menuId,
                pid: c.menuId,
                menuName: "查看",
                menuId: "",
              },
            ];
            if (!isde) {
              c.btnIds = c.btnIds ? c.btnIds.split(",") : [];
              c.btnIds.forEach((b) => {
                var btn = this.btnlistData.find((r) => r.btnId == b);
                if (btn) {
                  c.children.push({
                    disabled: btn.status == 0,
                    type: "btn",
                    key: c.menuId + "btn" + btn.btnId,
                    pid: c.menuId,
                    menuName: btn.btnName,
                    menuId: btn.btnId,
                  });
                }
              });
            }
          });
        }
        if (!isde) {
          e.btnIds = e.btnIds ? e.btnIds.split(",") : [];
          e.btnIds.forEach((b) => {
            var btn = this.btnlistData.find((r) => r.btnId == b);
            if (btn) {
              e.children.push({
                disabled: btn.status == 0,
                type: "btn",
                key: e.menuId + "btn" + btn.btnId,
                pid: e.menuId,
                menuName: btn.btnName,
                menuId: btn.btnId,
              });
            }
          });
        }
        temp.push(e);
      });
      // console.log(temp);
      this.menulistTreeData = temp;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.menuName.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 250px !important;
}
</style>
